import { Card, CardContent, LinearProgress } from "@material-ui/core";
import Axios from "axios";
import React, { Component } from "react";
import { Table } from "react-bootstrap";
import AppConfig from "../../../../config/AppConfig";
import Chart1a from "./component/Chart1a";
import Chart1b from "./component/Chart1b";
import Chart2a from "./component/Chart2a";
import Chart2b from "./component/Chart2b";
class InformasiDasar extends Component {
  state = {
    lembaga: "1",
    status: false,
    loading1: false,
    loading2: false,
    data_loaded1: false,
    data_loaded2: false,
    data_chart1: [],
    data_chart2: [],
    total_data1: [],
    total_data2: [],
  };

  onChangeMenu = (e, type) => {
    this.setState({
      [type]: e.target.value,
      status: true,
    });
  };

  modifyStatus = (data) => {
    this.setState({ status: data });
  };

  // Get Data ============================================================================
  getDataChart1() {
    this.setState({
      loading1: true,
    });
    let id_institusi = localStorage.getItem("id_sp_temp");
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let id_sp = sessiondata.i_idunit;
    if (id_institusi !== "") {
      id_sp = id_institusi;
    }
    if (id_institusi === null) {
      id_sp = sessiondata.i_idunit;
    }
    let session = "";
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    if (userdata) {
      session =
        "?tipe_lembaga=" +
        this.props.tipe_lembaga +
        "&id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        id_sp +
        "&id_role=" +
        sessiondata.i_idrole + 
        "&id_bp=" +
        sessiondata.i_idbp;
    }
    Axios.get(AppConfig.DetailDashboard + "sebaranptvbykategori" + session)
      .then((res) => {
        // console.log("Data chart1", res.data.result.data_vokasi);
        this.setState({
          loading1: false,
          data_loaded1: true,
          data_chart1: res.data?.result?.data_vokasi,
          total_data1: res.data?.result?.data_belmawa,
        });
      })
      .catch((err) => {
        alert("not found");
      });
  }
  getDataChart2() {
    this.setState({
      loading2: true,
    });
    let id_institusi = localStorage.getItem("id_sp_temp");
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let id_sp = sessiondata.i_idunit;
    if (id_institusi !== "") {
      id_sp = id_institusi;
    }
    if (id_institusi === null) {
      id_sp = sessiondata.i_idunit;
    }
    let session = "";
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    if (userdata) {
      session =
        "?tipe_lembaga=" +
        this.props.tipe_lembaga +
        "&id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        id_sp +
        "&id_role=" +
        sessiondata.i_idrole + 
        "&id_bp=" +
        sessiondata.i_idbp;
    }
    Axios.get(AppConfig.DetailDashboard + "sebaranptvbywilayah" + session)
      .then((res) => {
        // console.log("Data chart2", res.data.result.data);
        this.setState({
          loading2: false,
          data_loaded2: true,
          data_chart2: res?.data?.result?.data_vokasi,
          total_data2: res?.data?.result?.data_belmawa,
        });
      })
      .catch((err) => {
        alert("not found");
      });
  }
  async componentDidMount() {
    this.getDataChart1();
    this.getDataChart2();
  }

  render() {
    let userdata = JSON.parse(localStorage.getItem("sessiondata"));
    let access = userdata.i_idbp;

    let i = 0;
    let list_data_chart1 = [];
    let list_data_chart2 = [];

    if (this.state.data_loaded1 === true) {
      if (access !== 2) {
        for (var index in this.state.total_data1) {
          list_data_chart1[i] = {
            result: this.state.total_data1[index],
            key: index,
          };
          i++;
        }
        // console.log(list_data_chart1);
      } else {
        for (var index in this.state.data_chart1) {
          list_data_chart1[i] = {
            result: this.state.data_chart1[index],
            key: index,
          };
          i++;
        }
        // console.log(list_data_chart1);
      }
    }
    if (this.state.data_loaded2 === true) {
      if (access !== 2) {
        for (var index in this.state.total_data2) {
          list_data_chart2[i] = {
            result: this.state.total_data2[index],
            key: index,
          };
          i++;
        }
        console.log(list_data_chart2);
      } else {
        for (var index in this.state.data_chart2) {
          list_data_chart2[i] = {
            result: this.state.data_chart2[index],
            key: index,
          };
          i++;
        }
        // console.log(list_data_chart2);
      }
    }

    return (
      <>
        <Card className="mt-10">
          <CardContent>
            <div className="row row-paddingless">
              <div
                className="col-md-12 col-xxl-12"
                style={{ textAlign: "center" }}
              >
                <h3
                  className="card-title font-weight-bolder mt-5"
                  style={{ color: "#354f7a" }}
                >
                  Informasi Dasar
                </h3>
                <div className="row mb-5">
                  <div className="col-md-2 offset-md-5">
                    <select
                      name="display"
                      className={`form-control form-control-lg form-control-solid `}
                      style={{ paddingLeft: "0px 20px 0px 20px" }}
                      onChange={(e) => this.onChangeMenu(e, "lembaga")}
                    >
                      <option value="1">Kemendikbud</option>
                      <option value="2">Kementerian Luar</option>
                    </select>
                  </div>
                </div>
              </div>
              <div
                className="col-md-12 col-xxl-12 pl-20 pr-20"
                style={{ textAlign: "center" }}
              >
                <h5
                  className="card-title font-weight-bolder mt-5"
                  style={{ color: "#354f7a" }}
                >
                  Sebaran Perguruan Tinggi Berdasarkan Kategori dan Wilayah
                </h5>
                {access === 2 ? (
                  <Chart1a
                    tipe_lembaga={this.state.lembaga}
                    status={this.state.status}
                    parentCallback={this.modifyStatus}
                  />
                ) : (
                  <Chart1b
                    tipe_lembaga={this.state.lembaga}
                    status={this.state.status}
                    parentCallback={this.modifyStatus}
                  />
                )}
              </div>
              <br />
              <div
                className="col-md-12 col-xxl-12"
                style={{
                  textAlign: "center",
                  marginTop: "20px",
                }}
              >
                <div className={`card-custom`}>
                  {/* Body */}
                  <div className="card-body pt-2">
                    {/* Table Here */}
                    {access === 2 ? (
                      <Table responsive hover style={{ overflow: "auto" }}>
                        <thead
                          className="text-white"
                          style={{ backgroundColor: "#3047ad" }}
                        >
                          <tr>
                            <th
                              style={{
                                width: "20%",
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Wilayah
                            </th>
                            <th
                              className="text-center"
                              style={{
                                width: "20%",
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Akademi Negeri
                            </th>
                            <th
                              className="text-center"
                              style={{
                                width: "20%",
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Akademi Swasta
                            </th>
                            <th
                              style={{
                                width: "20%",
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                              }}
                            >
                              Akademi Komunitas Negeri
                            </th>
                            <th
                              style={{
                                width: "20%",
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                              }}
                            >
                              Akademi Komunitas Swasta
                            </th>
                            <th
                              className="text-center"
                              style={{
                                width: "20%",
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Politeknik Negeri
                            </th>
                            <th
                              className="text-center"
                              style={{
                                width: "20%",
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Politeknik Swasta
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.loading1 === true ? (
                            <tr>
                              <td colSpan="7">
                                <LinearProgress
                                  color="secondary"
                                  variant="query"
                                />
                              </td>
                            </tr>
                          ) : this.state.data_loaded1 === true ? (
                            list_data_chart1.map((list) => (
                              <tr key={list.key}>
                                <td style={{ verticalAlign: "middle" }}>
                                  <b>{list.key}</b>
                                </td>
                                <td style={{ verticalAlign: "middle" }}>
                                  {list.result.akademi_negeri}
                                </td>
                                <td style={{ verticalAlign: "middle" }}>
                                  {list.result.akademi_swasta}
                                </td>
                                <td style={{ verticalAlign: "middle" }}>
                                  {list.result.ak_negeri}
                                </td>
                                <td style={{ verticalAlign: "middle" }}>
                                  {list.result.ak_swasta}
                                </td>
                                <td style={{ verticalAlign: "middle" }}>
                                  {list.result.politeknik_negeri}
                                </td>
                                <td style={{ verticalAlign: "middle" }}>
                                  {list.result.politeknik_swasta}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <>
                              <tr>
                                <td colSpan="7" style={{ textAlign: "center" }}>
                                  <em>Data does not exist</em>
                                </td>
                              </tr>
                            </>
                          )}
                        </tbody>
                      </Table>
                    ) : (
                      <Table responsive hover style={{ overflow: "auto" }}>
                        <thead
                          className="text-white"
                          style={{ backgroundColor: "#3047ad" }}
                        >
                          <tr>
                            <th
                              style={{
                                width: "20%",
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Wilayah
                            </th>
                            <th
                              className="text-center"
                              style={{
                                width: "20%",
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Akademi Negeri
                            </th>
                            <th
                              className="text-center"
                              style={{
                                width: "20%",
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Akademi Swasta
                            </th>
                            <th
                              style={{
                                width: "20%",
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                              }}
                            >
                              Akademi Komunitas Negeri
                            </th>
                            <th
                              style={{
                                width: "20%",
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                              }}
                            >
                              Akademi Komunitas Negeri
                            </th>
                            <th
                              className="text-center"
                              style={{
                                width: "20%",
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Politeknik Negeri
                            </th>
                            <th
                              className="text-center"
                              style={{
                                width: "20%",
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Politeknik Swasta
                            </th>
                            <th
                              className="text-center"
                              style={{
                                width: "20%",
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Sekolah Tinggi Negeri
                            </th>
                            <th
                              className="text-center"
                              style={{
                                width: "20%",
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Sekolah Tinggi Swasta
                            </th>
                            <th
                              className="text-center"
                              style={{
                                width: "20%",
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Institut Negeri
                            </th>
                            <th
                              className="text-center"
                              style={{
                                width: "20%",
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Institut Swasta
                            </th>
                            <th
                              className="text-center"
                              style={{
                                width: "20%",
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Universitas Negeri
                            </th>
                            <th
                              className="text-center"
                              style={{
                                width: "20%",
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Universitas Swasta
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.loading1 === true ? (
                            <tr>
                              <td colSpan="7">
                                <LinearProgress
                                  color="secondary"
                                  variant="query"
                                />
                              </td>
                            </tr>
                          ) : this.state.data_loaded1 === true ? (
                            list_data_chart1.map((list) => (
                              <tr key={list.key}>
                                <td style={{ verticalAlign: "middle" }}>
                                  <b>{list.key}</b>
                                </td>
                                <td style={{ verticalAlign: "middle" }}>
                                  {list.result.akademi_negeri}
                                </td>
                                <td style={{ verticalAlign: "middle" }}>
                                  {list.result.akademi_swasta}
                                </td>
                                <td style={{ verticalAlign: "middle" }}>
                                  {list.result.ak_negeri}
                                </td>
                                <td style={{ verticalAlign: "middle" }}>
                                  {list.result.ak_swasta}
                                </td>
                                <td style={{ verticalAlign: "middle" }}>
                                  {list.result.politeknik_negeri}
                                </td>
                                <td style={{ verticalAlign: "middle" }}>
                                  {list.result.politeknik_swasta}
                                </td>
                                <td style={{ verticalAlign: "middle" }}>
                                  {list.result.st_negeri}
                                </td>
                                <td style={{ verticalAlign: "middle" }}>
                                  {list.result.st_swasta}
                                </td>
                                <td style={{ verticalAlign: "middle" }}>
                                  {list.result.institut_negeri}
                                </td>
                                <td style={{ verticalAlign: "middle" }}>
                                  {list.result.institut_swasta}
                                </td>
                                <td style={{ verticalAlign: "middle" }}>
                                  {list.result.universitas_negeri}
                                </td>
                                <td style={{ verticalAlign: "middle" }}>
                                  {list.result.universitas_swasta}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <>
                              <tr>
                                <td colSpan="7" style={{ textAlign: "center" }}>
                                  <em>Data does not exist</em>
                                </td>
                              </tr>
                            </>
                          )}
                        </tbody>
                      </Table>
                    )}
                  </div>
                </div>
              </div>

              <div
                className="col-md-12 col-xxl-12 pl-20 pr-20"
                style={{ textAlign: "center" }}
              >
                <h5
                  className="card-title font-weight-bolder mt-5"
                  style={{ color: "#354f7a" }}
                >
                  Sebaran Perguruan Tinggi di Indonesia Berdasarkan Wilayah
                </h5>
                {access === 2 ? (
                  <Chart2a
                    tipe_lembaga={this.state.lembaga}
                    status={this.state.status}
                    parentCallback={this.modifyStatus}
                  />
                ) : (
                  <Chart2b
                    tipe_lembaga={this.state.lembaga}
                    status={this.state.status}
                    parentCallback={this.modifyStatus}
                  />
                )}
              </div>
              <br />
              <div
                className="col-md-12 col-xxl-12"
                style={{
                  textAlign: "center",
                  marginTop: "20px",
                }}
              >
                <div className={`card-custom`}>
                  {/* Body */}
                  <div className="card-body pt-2">
                    {/* Table Here */}
                    {access === 2 ? (
                      <Table responsive hover style={{ overflow: "auto" }}>
                        <thead
                          className="text-white"
                          style={{ backgroundColor: "#3047ad" }}
                        >
                          <tr>
                            <th
                              style={{
                                width: "20%",
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Wilayah
                            </th>
                            <th
                              style={{
                                width: "20%",
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                              }}
                            >
                              Akademi
                            </th>
                            <th
                              style={{
                                width: "20%",
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                              }}
                            >
                              Akademi Komunitas
                            </th>
                            <th
                              className="text-center"
                              style={{
                                width: "20%",
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Politeknik
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.loading2 === true ? (
                            <tr>
                              <td colSpan="4">
                                <LinearProgress
                                  color="secondary"
                                  variant="query"
                                />
                              </td>
                            </tr>
                          ) : this.state.data_loaded2 === true ? (
                            list_data_chart2.map((list) => (
                              <tr key={list.key}>
                                <td style={{ verticalAlign: "middle" }}>
                                  <b>{list.key}</b>
                                </td>
                                <td style={{ verticalAlign: "middle" }}>
                                  {list.result.akademi}
                                </td>
                                <td style={{ verticalAlign: "middle" }}>
                                  {list.result.akademi_komunitas}
                                </td>
                                <td style={{ verticalAlign: "middle" }}>
                                  {list.result.politeknik}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <>
                              <tr>
                                <td colSpan="4" style={{ textAlign: "center" }}>
                                  <em>Data does not exist</em>
                                </td>
                              </tr>
                            </>
                          )}
                        </tbody>
                      </Table>
                    ) : (
                      <Table responsive hover style={{ overflow: "auto" }}>
                        <thead
                          className="text-white"
                          style={{ backgroundColor: "#3047ad" }}
                        >
                          <tr>
                            <th
                              style={{
                                width: "20%",
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Wilayah
                            </th>
                            <th
                              style={{
                                width: "20%",
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                              }}
                            >
                              Akademi
                            </th>
                            <th
                              style={{
                                width: "20%",
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                              }}
                            >
                              Akademi Komunitas
                            </th>
                            <th
                              className="text-center"
                              style={{
                                width: "20%",
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Politeknik
                            </th>
                            <th
                              className="text-center"
                              style={{
                                width: "20%",
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Sekolah Tinggi
                            </th>
                            <th
                              className="text-center"
                              style={{
                                width: "20%",
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Institut
                            </th>
                            <th
                              className="text-center"
                              style={{
                                width: "20%",
                                fontSize: "12px",
                                textTransform: "uppercase",
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Universitas
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.loading2 === true ? (
                            <tr>
                              <td colSpan="4">
                                <LinearProgress
                                  color="secondary"
                                  variant="query"
                                />
                              </td>
                            </tr>
                          ) : this.state.data_loaded2 === true ? (
                            list_data_chart2.map((list) => (
                              <tr key={list.key}>
                                <td style={{ verticalAlign: "middle" }}>
                                  <b>{list.key}</b>
                                </td>
                                <td style={{ verticalAlign: "middle" }}>
                                  {list.result.akademi}
                                </td>
                                <td style={{ verticalAlign: "middle" }}>
                                  {list.result.akademi_komunitas}
                                </td>
                                <td style={{ verticalAlign: "middle" }}>
                                  {list.result.politeknik}
                                </td>
                                <td style={{ verticalAlign: "middle" }}>
                                  {list.result.sekolah_tinggi}
                                </td>
                                <td style={{ verticalAlign: "middle" }}>
                                  {list.result.institut}
                                </td>
                                <td style={{ verticalAlign: "middle" }}>
                                  {list.result.universitas}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <>
                              <tr>
                                <td colSpan="4" style={{ textAlign: "center" }}>
                                  <em>Data does not exist</em>
                                </td>
                              </tr>
                            </>
                          )}
                        </tbody>
                      </Table>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      </>
    );
  }
}
export default InformasiDasar;
